// Feature Names for the feature flags
export const Features = {
  AI_CHATBOT: 'fflag.ai.chatbot',
  CHINA_LIFETIME_PLAN_OFFER: 'fflag.account.chinaLifetimePlanOffer',
  COBALT_UPSELL: 'fflag.account.cobaltUpsell',
  WAYFLYER_INTEGRATION: 'fflag.account.wayflyerIntegration',
  COMPETITIVE_INTELLIGENCE_UPGRADE_INCENTIVE:
    'fflag.competitiveIntelligence.upgradeIncentive',
  PPC_UPDATE_BANNERS: 'fflag.account.ppcUpdatePermissionsBanner',
  PROFIT_OVERVIEW_DEMO_PREVIEW: 'fflag.profitOverview.demoPreview',
  SELLER_FEATURES_DISABLED: 'fflag.sellerFeatures.disabled',
  SELLER_FEATURES_MAINTENANCE: 'fflag.sellerFeatures.maintenance',
  LISTING_BUILDER_DISABLE_SYNC: 'fflag.listingBuilder.disableSync'
}
